import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionsModuleAccessLevel } from '@predictiveindex/client-permissions-lib';
import {
    IDropDownItem,
    TapestrySidenavService
} from '@predictiveindex/tapestry';
import { adminRoutePath } from '../../../constants-types/Route.constants';
import { SiteNavigationService } from '../../../core-services';
import {
    FeatureFlags,
    FeatureFlagsService,
    InitDataService,
    Logger,
    ModuleUserAccessService
} from '../../../system-services';
import { TranslationService } from '../../../translations';
import { GlobalNavService } from '../global-nav.service';

@Component({
    selector: 'settings-dropdown',
    templateUrl: './settings-dropdown.component.html',
    standalone: false
})
export class SettingsDropdownComponent implements OnInit {
    @Output()
    adminClick: EventEmitter<void> = new EventEmitter();

    sideNavTitleKey = 'module-userManagement.title';
    settingsDropDownItems: IDropDownItem[];
    isGlobalAdminEnabled = false;

    constructor(
        private router: Router,
        private moduleUserAccessService: ModuleUserAccessService,
        private featureFlags: FeatureFlagsService,
        public tapestrySidenavService: TapestrySidenavService,
        public siteNavigation: SiteNavigationService,
        public TR: TranslationService,
        public nav: GlobalNavService,
        private logger: Logger,
        private init: InitDataService
    ) {
        this.isGlobalAdminEnabled = this.featureFlags.getByFlag(
            FeatureFlags.enableGlobalAdmin
        );
    }

    ngOnInit(): void {
        this.buildSettingsDropDownItems();
    }

    menuAction(id: string): void {
        // Log click
        this.logger.logInfo(`Global Nav - Gear icon dropdown item click`, {
            userId: this.init.user.userId,
            email: this.init.user.email,
            companyId: this.init.user.companyId,
            fullDisplayedMenu: this.settingsDropDownItems,
            clickedItem: id
        });
        switch (id) {
            case 'selectSubscription':
                this.router.navigateByUrl('subscription');
                break;
            case 'selectBillings':
                this.router.navigateByUrl('billing');
                break;
            default:
                break;
        }
    }

    buildSettingsDropDownItems(): void {
        this.settingsDropDownItems = [
            {
                title: this.TR.key('globalnav.userSettingsMenu.subscriptions'),
                id: 'selectSubscription'
            }
        ];

        if (
            this.moduleUserAccessService.hasAccessLevelForAnyModule(
                PermissionsModuleAccessLevel.AllCompanyAdmin
            )
        ) {
            this.settingsDropDownItems.push({
                title: this.TR.key('globalnav.userSettingsMenu.billing'),
                id: 'selectBillings'
            });
        }
    }

    goToGlobalAdmin(): void {
        this.adminClick.emit();
        this.router.navigate([`${adminRoutePath}`]);
    }
}
